import type { Adapters } from '../types';
import { webStorage } from './storage';
import { webIdentity } from './identity';
import { webShare } from './share';
import { webLifecycle } from './lifecycle';
import { webNavigation } from './navigation';

export const webAdapters: Adapters = {
  storage: webStorage,
  identity: webIdentity,
  share: webShare,
  lifecycle: webLifecycle,
  navigation: webNavigation,
};
